<template>
  <div class="app-container">
    <el-aside style="padding-right: 10px; padding-top: 0px;float:left;width:27%;height:100%;background:none;">
      <div class="block" style="width:100%;height:100%;background-color: #FFF">
        <div style="float: left;width: 33%;text-align: center;background-color: #FFF; margin-bottom: 10px;font-size: 14px;" @click="loadTree('0')">
          <span>
            <i> <img :src=img1 style='width: 26px;height: 26px;margin-right:5px;padding-top:1px;padding-bottom:5px' /></i>
            <p class='style-demo'>全部({{this.wholeNum}})</p>
          </span>
        </div>
        <div style="float: left;width: 33%;text-align: center;background-color: #FFF; margin-bottom: 10px;font-size: 14px;" @click="loadTree('1')">
          <span>
            <i> <img :src=img2 style='width: 26px;height: 26px;margin-right:5px;padding-top:1px;padding-bottom:5px' /></i>
            <p class='style-demo'>在线({{this.onlineNum}})</p>
          </span>
        </div>
        <div style="float: left;width: 33%;text-align: center;background-color: #FFF; margin-bottom: 10px;font-size: 14px;" @click="loadTree('2')">
          <span>
            <i> <img :src=img3 style='width: 26px;height: 26px;margin-right:5px;padding-top:1px;padding-bottom:5px' /></i>
            <p class='style-demo'>离线({{this.offlineNum}})</p>
          </span>
        </div>
        <el-input v-model="filterText" style="width:100%;padding-bottom: 10px" placeholder="关键字过滤" clearable />
        <el-tree
          id="el-tree"
          ref="tree"
          class="filter-tree"
          :data="treeData"
          node-key="id"
          v-loading="treeLoading"
          :highlight-current="true"
          :props="defaultProps"
          :default-expand-all="false"
          :expand-on-click-node="true"
          :default-expanded-keys="TreeArr"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
        >
          <span slot-scope="{ node }">
            <span style="font-size: 14px;">
              <span v-if="node.level !== 3 ">{{ node.label }}</span><span v-if="node.level !== 3 ">({{ node.data.childrenNum}})</span>
              <span v-if="node.level === 3 && node.data.status === '1'" style="color: green;">{{ node.label }}</span>
              <span v-if="node.level === 3 && node.data.status === '2'" style="color: grey;">{{ node.label }}</span>
            </span>
          </span>
        </el-tree>
      </div>
    </el-aside>

    <el-aside style="padding-right: 5px; padding-left: 5px; padding-top: 0px;float:left;width:73%;background:none;">
      <map-container ref="MapContainer" :visable="visableMapEdit" :pagekey="pagekey" :proid="code" ></map-container>
    </el-aside>

  </div>
</template>

<script>
import { getTreeData, getAgainLoading } from '@/api/epvVehicle'

import MapContainer from "@/components/mapRouter/amap"
import { tableHeight3 } from '@/utils/tableHeight'

export default {
  mixins: [tableHeight3],
  components: { MapContainer },
  provide() {
    return {
      getList: this.loadList
    }
  },
  data() {
    return {
      treeLoading: false,
      treeData: [],
      TreeArr: [],
      IdArr: [],
      filterText: '', // 树，过滤节点搜索字符串
      selectNode: {}, // 记录当前点击节点
      rDATA: null, // 记录右键点击节点对象数据
      rNODE: null, // 记录右键点击节点
      optionCardX: 0,
      optionCardY: 0,
      img1: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAAD7UlEQVRYCe2Wy0vUURTH59Hg9NAxHXTGcZNMaoluCiIpcFNCtGtRELXpP0giKqUgC4Jq1bpFUeAmWrWojWEPKCNQzFEjIQhfmZEVjo+ZPl+9M8zj9/uNFNVmDny59557v+d3fufee851uYpSjEAxAn83Au5C5pubm7fG4/FO1u0HjeA9eOHz+bqHhoYm6edJU1NTaGlpSZxWEAUx0FdSUtI9ODg4R99WHB2qr6+XEz0gDJJgAoSAB3wBJ0ZHRx/RpgXOIQZ3QQVIADktvr4l/lE4fbSWIsOWosgwIWeq3W739eXl5a0YihCZALqLoBTcw4EI7aqY/n0Gmrvo9/vLxBFXNtBVgx5jm26+ePNVa5ry8vIr9A5i6MbIyMiZubm5uGZmZmYWZ2dnnwaDwUWGh0GQ8UPNVVZW3qLZA+cCjlydmppakl5c1jyBI0fbV1ZWfIwfay5XbCPEQm1XkrPQnUvSOBwO3+DDP+lqXUr2S6e5lCKzNba09ZmczCWr+5qlSA0I/zz9bwp5SpfbsqYf3S62UX/u4oPivIGzW2MrgfMJfSlryqzmnSI0BiHU0tKy2YpodKvbyBaUCEa3YLfe2NKl0E21FCeHXsLwLCwsdFgyf0NpbOmbL+zotg6xDZch6Wp3NjQ0nG1ra9tgZ6SQXlzZkC3wRTnMjlMoDymn3APlOqzJZHKYfuaWtDAu9Xg8QVpXIpH4TKNzNKCxET/cHXA3Mf4KjnN+snJXaqFaR4e0IBqN1vJBpQDdjG3S5UqOQ7nTGo8DJcPzOKNDbSsFHcpkUhK2ZBze9FQsFtPWuhobG5Wds8Tr9cYpMd+zlA4D2zPkwPmrUwUjZMrBVbzYB+qsvFnHln2A9wz82ZbhjA61alPgvx9q84QYwplSnOlSOejt7V1mnBYcfs6gNSdCzzm4imZadO0nJiY6uGlKJfNc+ya7p4vtGaIMdEGuwJnLFNdruc6kv7aOjriywVLlnwpsKx9Ziq1DrN4LEjyqbloyf0PJc0RFV28kPdwsxcmh7TAmBwYGflgy15Sr9UtXWzDr/HbrjS092KJ2a5wcUlYO19XV6UGWJ6aU7GTig/KMyTXjysp2ZcbYCsOJ5Rk0CieHlFndHEDL/dYhZX4j0HVOSZ9KhJlL6dKtsaVUI9uW4rXUoqypqXlNVj5J94BeeoFA4JVefnpC0D+H/hJQ3TrC60+tXoyvaU6BdvruSCTSr1ejIlNVVdWNs6eZm+RcHpuens6siajXxDExcq1Vv/7pI982QvKXP/9IpG4TKR9DoRa8Aw8I/zFq2Fv6WQJnLBQK3aHyq7qLUwNU/XsUmeHh4RH6RSlGoBiB/xaBXw/cj4I98dZuAAAAAElFTkSuQmCC',
      img2: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAACVklEQVRYCe2WMUgbYRTHc5c0W1y66lDIJRlcSrYu4tDBToIuXaxOLgodCoWCInVxDDjVRXEQdLB0sRRKoWOXDsVAkgtdMjtI6NA0ufP3zjsS9C7m+3IWh/vg5Xvfu++997//976XS6WSkTCQMHC/DBhR4QuFwhzP9pDJqD2a9hZ+q41G43OYvxlm9G33AUZCTyEf/By3pswtS9/gMcObpPsmT3NvrFWWLsyLv4AKHcMABQ5OoPyPeRRAd+Iol8uP2u32FhuXEdN13cNsNrtRrVY7rJVGLIAAc0JWC3llGIYwutvpeFjeKqFh87CiHjUWGIxz0zRnqLev9Xr9G+t1ZGnUAIP7xgUkbcMFxEa3231mWdYbCc6RSVyt2tMCJDXDbflYLBbfCwD0eRg6Rv1dKpUeM1eQA0R5aAHyC9jiWCqw8pysR+jLtm2fws5r1nYul9tSRoODblGv4LtUq9Uu8vl8BzCLHNuZAGDeZNLuVVoMkRAM3m1KNZvN7xzXD45vW+zjgMFXjyHpM/juAmINPe04jtSMjWgzg683tI5Mmp7fZ46IIiD2dWvmGkb/VwuQ34Gl6Sk3vn7qcE23hsKjxWC9kyFu0dMY8gQhgu+vyFqLBESxnnOTprlBP4NoMc6/omJFAspkMi97vd4OjlFfjE94NoE0kUtERhmRtx/2Ei1e9p1sjnXQoT/Jxxbywg9s+Ou/4yR6cEUdJ6CgYIWgQV2JMCVHOvMs539Khhxy81s7LPEfLsUC/3lfwh6G2ZQYAozsFyCjgJF8Dj7/RElGwkDCwENh4Ao9EqSXu2b40QAAAABJRU5ErkJggg==',
      img3: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJKADAAQAAAABAAAAJAAAAAAqDuP8AAACcklEQVRYCe2Wv2sUQRTHs5cFtYiFdncnXOB+NDaiiCDoWSgYIREtRLRXEFKk1M7KWkTRP0CwCfkhJ6KFjYEQSCEW90PhIMchQZAUoiK3m887dy6LtzvOThJJsQPv3uy8X995783cjIykI81AmoHdzYAT575cLl9E9gzKx+lYrq9hd6vZbL6Kss9ELQZruwFGXB+BngYxhpg7tLK10M8MOxndWurP/L++k3z6ZF7sBVTk0AFSBp6a/A+uK5lRfHb8qFQqnRHlYrG4z8hIo2QNCBD3AXMS3zXHcSrM32QymXX4Z4Cd0sTUiqwB+b5fgy7QYzUiXGa+kM1mD8OnAfZcG9VGyE5VAw6ZI3tYqVQmQ4JB41erVRf5RqFQ2B+SD6Y6v6JklSEyMOt53iGcvwx89FTEbrd7m/lKu93+qdaScCtA9Xr9HX1zk/K8Jlj4FIq/CegFfXQ2CRClawUoKMeJXC73RDmCiy+PnpoA7DpZnArJjKdWgIJyfKM854OeuUP5FiUqp+8e5fwCsBljFCFFK0BiTwZuwB4D6iv8CjRHo0tW3kKXIKthclNHOqaPlhCM5/P5A51O5wdgTtNT11qt1jTry5FGBovWgJRvASPzRqPxHia0rWFdsm1F1Rj/M0Mc32Ma+6Qi9f6KfTHEAqIfPnJ8j9K8q0mjGuh/iNOJBeS67vVer/cAw7gX4ziyg9AnaAOScRyS3es2scZm74ryjg7um/ngf0luZhlO8P3rz6fd755r6p0EpBq2ny27/JDmJIZcfueo/yw2Y9DgyaHx8Z1DcZVLVP6EjUaiDAFG9AWICRgB4GHzWybpSDOQZmCvZGATlJmteWTesJIAAAAASUVORK5CYII=',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      wholeNum: 0,
      onlineNum: 0,
      offlineNum: 0,      
      visableMapEdit: '1', // 地图内容是否可编辑
      pagekey: '3', // 实时监控
      code: null,
      flag: ''
    }
  },
  // 监听过滤节点
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  created() {
    // 加载树
    this.onloadList()
  },
  methods: {
    onloadList() {
      this.TreeArr = []
      this.IdArr = []
      // 重新加载表格
      this.loadTree('0')
    },
    // 加载树
    loadTree(flag) {
      this.treeLoading = true
      this.flag = flag
      this.treeData = []
      this.TreeArr = []
      this.IdArr = []
      getTreeData({flag: flag}).then(response => {
        if (response.code === 20000) {
          this.treeLoading = false
          this.treeData = response.data.treeData
          this.wholeNum = response.data.wholeNum
          this.onlineNum = response.data.onlineNum
          this.offlineNum = response.data.offlineNum

          this.treeData.forEach(m => {
            this.TreeArr.push(m.id)
          })
        }
      })
    },
    // 过滤节点，展示所有符合条件的树节点
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 点击节点，1：展开/关闭下级节点；2：查询右面列表数据
    handleNodeClick(data, node, e) {
      var dataA = data
      this.selectNode = data
      this.selectNode.level = node.level
      // this.loadList()

      if (node.level < 3) {
        if (!this.IdArr.includes(dataA.id)) {
          // 树
          getAgainLoading({ companyId: dataA.id, flag: this.flag }).then(response => {
            if (!dataA.children) {
              this.$set(dataA, 'children', [])
              response.data.forEach(newChild => {
                dataA.children.push(newChild)
              })
              this.IdArr.push(dataA.id)
              this.dataId = dataA.id
            } else {
              return
            }

            this.listLoading = false
          }).catch(response => {
            this.listLoading = false
          })
        }
      } else {
        // 点击车辆
        this.handleTruck(data)
      }
    },
    handleTruck(e){
      this.code = e.plateNumber
      this.$nextTick(() => {
        this.$refs.MapContainer.getDetailed()
      })
    }
  }
}
</script>

<style scoped>
  .app-container {
    height: calc(100% - 20px);
    width: calc(100% - 20px);
    padding: 10px 0;
    margin: 0 auto;
  }

  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .pagination-container {
    margin-top: 0 !important;
    padding: 10px 16px !important;
  }
</style>
